import { GetPremiumModal } from "@/modules/app/components/get-premium-modal"
import { usePremiumModal } from "@/modules/app/stores/use-premium-modal"
import { Outlet } from "react-router-dom"
import NoLifeAlert from "@/modules/app/components/no-life-alert"

export default function Body(): React.ReactElement {
  const { isOpen, onToggle } = usePremiumModal()
  return (
    <div className="mb-[120px] flex h-full w-full md:mb-0">
      <Outlet />
      <GetPremiumModal open={isOpen} onToggle={onToggle} />
      <NoLifeAlert />
    </div>
  )
}
